
export const OFFER_ORDER_FIELD = "sortOrder";
export const OFFER_GROUP_ORDER_FIELD = "groupSortOrder";
